import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoorOpeningClosing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20 20.5H4C3.60218 20.5 3.22064 20.658 2.93934 20.9393C2.65804 21.2206 2.5 21.6022 2.5 22V23C2.5 23.2652 2.60536 23.5196 2.79289 23.7071C2.98043 23.8946 3.23478 24 3.5 24H20.5C20.7652 24 21.0196 23.8946 21.2071 23.7071C21.3946 23.5196 21.5 23.2652 21.5 23V22C21.5 21.6022 21.342 21.2206 21.0607 20.9393C20.7794 20.658 20.3978 20.5 20 20.5Z",
		fill: "#C6CDD2"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 19H19C19.1326 19 19.2598 18.9473 19.3536 18.8536C19.4473 18.7598 19.5 18.6326 19.5 18.5V1.5C19.5 1.10218 19.342 0.720644 19.0607 0.43934C18.7794 0.158035 18.3978 0 18 0L6 0C5.60218 0 5.22064 0.158035 4.93934 0.43934C4.65804 0.720644 4.5 1.10218 4.5 1.5V18.5C4.5 18.6326 4.55268 18.7598 4.64645 18.8536C4.74021 18.9473 4.86739 19 5 19ZM15.5 9C15.7967 9 16.0867 9.08797 16.3334 9.2528C16.58 9.41762 16.7723 9.65189 16.8858 9.92597C16.9993 10.2001 17.0291 10.5017 16.9712 10.7926C16.9133 11.0836 16.7704 11.3509 16.5607 11.5607C16.3509 11.7704 16.0836 11.9133 15.7926 11.9712C15.5017 12.0291 15.2001 11.9994 14.926 11.8858C14.6519 11.7723 14.4176 11.58 14.2528 11.3334C14.088 11.0867 14 10.7967 14 10.5C14 10.1022 14.158 9.72064 14.4393 9.43934C14.7206 9.15804 15.1022 9 15.5 9Z",
		fill: "#C6CDD2"
	})]
});
export default SvgDoorOpeningClosing;
